import {Component, Input, OnInit} from '@angular/core';
import {PaymentStatusEnum} from "../../orders/orders.interface";
import {IEcommerceView} from "../../ecommerce-product.interface";
import {ActivatedRoute} from "@angular/router";
import {CustomersService} from "../customers.service";
import {DatePipe} from "@angular/common";
import {TextUtils} from "../../../../../shared/utils/text-utils";
import {ICustomerView, IOrdersView, IOrderView} from "./customer-view.interface";
import * as fromStore from "../../../../../store";
import {Store} from "@ngrx/store";
import {filter, first} from "rxjs/operators";
import {EcommerceService} from "../../ecommerce.service";
import {EcommerceAnalyticsLabel} from "../../ecommerce-product.enum";

@Component({
    selector: 'db-customer-view',
    templateUrl: './customer-view.component.html',
    styleUrls: ['./customer-view.component.scss'],
    standalone: false
})
export class CustomerViewComponent implements OnInit {
  @Input() headerGreedStyle = {
    'grid-template-columns': 'minmax(150px, 1fr) minmax(70px, 1fr) minmax(70px, 1fr) minmax(70px, 1fr)'
  };
  userId = this._activatedRoute.snapshot.params['customerId'];
  website = this._activatedRoute.snapshot.parent.parent.parent.data['website'];
  customer: ICustomerView;
  view: IEcommerceView;
  loading = true;
  heads = [
    TextUtils.getText('text_orderNumber'),
    TextUtils.getText('text_date'),
    TextUtils.getText('text_price'),
    TextUtils.getText('text_paymentStatus')
  ];
  orders: IOrderView[];
  private _analyticsActionName = 'Ecommerce - Customers';

  constructor(private _activatedRoute: ActivatedRoute,
              private _datePipe: DatePipe,
              private _store: Store<fromStore.DbStoreState>,
              private _ecommerceService: EcommerceService,
              private _customerService: CustomersService) {
  }

  ngOnInit() {
    this._getCustomer();
    this._getCustomerFiledListener();
    this._store.dispatch(new fromStore.LoadEcommerceCustomer({websiteId: this.website.id, id: this.userId}));
  }

  private _getCustomer() {
    this._store.select(fromStore.getCustomer(this.website.id))
      .pipe(
        filter(customer => {
          if (customer && customer.customer === null) {
            this._ecommerceService.sendAnalyticsEvent(this._analyticsActionName, EcommerceAnalyticsLabel.VIEW, true);
          }
          return !!customer && customer.customer.customer_id === this.userId;
        }),
        first()
      ).subscribe(response => {
      const {customer, ordersData} = response;
      this.customer = customer;
      this.orders = ordersData.orders.map(order => {
        order.payment_status = PaymentStatusEnum[order.status];
        return order;
      });
      this.view = this._transformToView(this.customer, ordersData);
      this.loading = false;
      this._ecommerceService.sendAnalyticsEvent(this._analyticsActionName, EcommerceAnalyticsLabel.VIEW);
    });
  }

  private _getCustomerFiledListener() {
    this._store.select(fromStore.getCustomerFailed(this.website.id))
      .pipe(filter(filed => filed), first())
      .subscribe(() => {
        this._ecommerceService.sendAnalyticsEvent(this._analyticsActionName, EcommerceAnalyticsLabel.VIEW, true);
      });
  }

  private _transformToView(customer: ICustomerView, order: IOrdersView): IEcommerceView {
    const totalSpent = +(order.priceList['completed'] || 0) + (order.priceList['processing'] || 0);
    const view: Partial<IEcommerceView> = {
      header: {
        previousPage: "Customers",
        currentPage: `ID ${this.userId}`,
        previousPath: "../customers"
      },
      stats: {
        header: {
          date: customer.date_registered ? `Customer since: ${this._datePipe.transform(customer.date_registered, 'MMM d, y')}` : '',
          name: customer.email,
        },
        stats: [
          {
            value: `$${totalSpent || 0}`,
            label: TextUtils.getText('text_amountSpent')
          },
          {
            value: `$${order.priceList['refunded'] || 0}`,
            label: TextUtils.getText('text_refunded')
          },
          {
            value: `${order.orders && order.orders.length}`,
            label: TextUtils.getText('text_orders')
          }
        ]
      }
    };


    return view as IEcommerceView;
  }

}
